<template>
  <div>
    <van-nav-bar
      title="注册"
      left-text="返回"
      left-arrow
      @click-left="$router.push('/login')"
    >
      <template #right>
        <!-- <van-icon name="wechat" size="25" @click="openQchat()" /> -->
        <!-- <van-image
          width="28px"
          height="22px"
          :src="require('../assets/images/chatbar.png')"
          @click="openQchat()"
        /> -->
        <span @click="openQchat()" class="chatTextDesign">在线客服</span>
      </template>
    </van-nav-bar>
    <div class="wrap">
      <div class="logo">
        <img
          :src="$store.state.login_logo_url"
          style="width: 100%"
          v-if="$store.state.login_logo_url"
        />
        <img v-else
          :src="require('../assets/images/logo.png')"
          style="width: 100%"
        />
      </div>
      <div>
        <p style="text-align: center; font-size: 19px; color: red">
          新会员最高专享礼
        </p>
        <p style="text-align: center; display: none">~最高可领~</p>
        <p style="text-align: center; font-size: 14px">
          注册送<span style="color: red"
            >&nbsp;{{ sys_give_voucher_amount }}&nbsp;元</span
          >&nbsp;+&nbsp;首充送&nbsp;<span style="color: red"
            >10000&nbsp;元&nbsp;</span
          >
          <!-- +&nbsp;交易&nbsp;<span style="color: red">9999&nbsp;元</span> -->
        </p>
        <!-- <p style="padding-top: 5px; color: red; text-align: center">
          豪礼一：新用户注册送&nbsp;{{ sys_give_voucher_amount }}&nbsp;元
        </p> -->
      </div>
      <van-form @submit="onRegister">
        <van-field
          v-model="phone"
          type="tel"
          name="phone"
          label="手机号码"
          placeholder="请输入手机号"
          autocomplete="off"
        />
        <van-field
          v-model="rePicCode"
          center
          clearable
          label="验证码"
          placeholder="请输入验证码"
        >
          <div slot="button">
            <img
              :src="captcha"
              @click="this.getCaptcha"
              style="height: 25px; width: 80px"
            />
          </div>
        </van-field>
        <van-field
          v-model="sms"
          center
          clearable
          label="短信验证码"
          placeholder="请输入短信验证码"
          autocomplete="off"
        >
          <template #button>
            <van-button
              size="small"
              plain
              type="info"
              native-type="button"
              @click="getPhoneCode"
              :disabled="disabled"
              >{{ getCodeText }}</van-button
            >
          </template>
        </van-field>
        <van-field
          v-model="password"
          type="password"
          name="password"
          label="设置密码"
          placeholder="请输入密码"
          autocomplete="off"
        />
        <van-field
          v-model="recommend"
          name="recommend"
          label="推荐人"
          placeholder="请输入推荐人"
          autocomplete="off"
        />
        <div style="margin: 16px">
          <van-button
            round
            block
            type="danger"
            size="small"
            native-type="submit"
            style="font-size:14px;"
          >
            注册
          </van-button>
        </div>
      </van-form>
    </div>
    <van-popup
      v-model="isRegisterSuccess"
      style="width: 70%; height: 151px; overflow: hidden"
    >
      <div>
        <h5 style="padding-top: 1px; text-align: center">您已注册成功</h5>
        <h5 style="padding-top: 1px; text-align: center">
          请登录领取<span>&nbsp;{{ sys_give_voucher_amount }}&nbsp;</span>元礼金
        </h5>
        <span
          ><van-button
            type="danger"
            size="small"
            @click="cancel"
            style="
              width: 42%;
              margin-left: 5%;
              margin-bottom: 5%;
              border-radius: 5px;
            "
            >取消
          </van-button>

          <van-button
            type="danger"
            size="small"
            @click="$router.push('/login')"
            style="
              width: 42%;
              margin-left: 5%;
              margin-bottom: 5%;
              border-radius: 5px;
            "
            >立即登录
          </van-button>
          <van-divider />
        </span>
      </div>
    </van-popup>
  </div>
</template>

<script>
import JSEncrypt from "jsencrypt/bin/jsencrypt";
export default {
  name: "Register",
  data() {
    return {
      phone: "",
      password: "",
      sms: "",
      recommend: "",
      disabled: false,
      getCodeText: "获取验证码",
      isRegisterSuccess: false,
      sys_give_voucher_amount: "",
      captcha: "",
      verify_token: "",
      rePicCode: "",
      qserver_url: "",
      rePicCode: "",
      captcha: "",
      verify_token: "",
    };
  },
  methods: {
    openQchat() {
      if (Capacitor.getPlatform() === "android") {
        //check if android app, if android app use native plugin to open popup
        Browser.open({ url: this.$store.state.chat_server_url });
      } else {
        window.open(this.$store.state.chat_server_url);
      }
    },
    get_qchat_server_url() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "server_url",
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            var data = res.data.data;
            that.qserver_url = data;
            that.$store.commit("chatServerUrl", that.qserver_url);
          } else if (res.data.code == 0) {
            that.$toast.fail(res.data.msg);
          }
        });
    },
    realNameConfig() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "sysconfig",
            token: sessionStorage.getItem("token"),
            name: "sys_give_voucher_amount",
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            //first time Recharge
            that.sys_give_voucher_amount = res.data.data;
          } else {
          }
        });
    },
    getPhoneCode() {
      let that = this;
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(that.phone)) {
        that.$toast.fail("手机号格式不正确");
      } else {
        let publicKey = localStorage.getItem("encript_public_key");
        let userPhone = that.phone.toString();
        let phoneNumber = that.encryptMessage(userPhone, publicKey);
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "register_code_e",
              rePicCode: that.rePicCode,
              phone: phoneNumber,
              verify_token: that.verify_token,
            },
          })
          .then(function (res) {
            if (res.data.code == 1) {
              that.$toast({
                message: res.data.msg,
                type: "success",
              });
              var time = 60;
              that.getCodeText = time + "s";
              that.disabled = true;
              var timer1 = setInterval(function () {
                time--;
                that.getCodeText = time + "s";
                if (time <= 0) {
                  that.getCodeText = "获取验证码";
                  that.disabled = false;
                  clearInterval(timer1);
                }
              }, 1000);
            } else if (res.data.code == 0) {
              that.$toast.fail(res.data.msg);
              // that.getCaptcha();
            }
          });
      }
    },
    getCaptcha() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "getSmsPic",
          },
        })
        .then(function (res) {
          let resData = res.data;
          if (resData.code == 1) {
            that.captcha = resData.data.code_url;
            that.verify_token = resData.data.verify_token;
          } else if (resData.code == 0) {
            that.disabled = false;
            that.$toast.fail(res.data.msg);
          }
        });
    },
    onRegister() {
      let that = this;
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(that.phone)) {
        that.$toast.fail("手机号格式不正确");
      } else {
        let publicKey = localStorage.getItem("encript_public_key");
        let userPhone = that.phone.toString();
        let phoneNumber = that.encryptMessage(userPhone, publicKey);
        let userPasword = that.encryptMessage(that.password, publicKey);
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "register_e",
              phone: phoneNumber,
              password: userPasword,
              code: that.sms,
              reid: that.recommend,
            },
          })
          .then(function (res) {
            if (res.data.code == 1) {
              // that.realNameConfig();
              that.isRegisterSuccess = true;
              // that.$toast({
              //   message: res.data.msg,
              //   type: "success",
              //   onClose:function () {
              //     that.$router.push('/login')
              //   }
              // });
            } else if (res.data.code == 0) {
              that.$toast.fail(res.data.msg);
            }
          });
      }
    },
    encryptMessage(message, publicKey) {
      const jsEncrypt = new JSEncrypt();
      jsEncrypt.setPublicKey(publicKey);
      return jsEncrypt.encrypt(message);
    },
    cancel() {
      this.isRegisterSuccess = false;
    },
    login() {
      this.$router.push("/login");
    },
    isLogin() {
      let that = this;
      if (that.$store.state.loginType) {
        that.$router.push("/members");
      }
    },
    isCode() {
      let that = this;
      let code = this.$route.query.code;
      let rePhone = window.sessionStorage.getItem("rePhone");

      if (!code && !rePhone) {
        that.recommend = "";

        // that.rePhone = code;
      } else {
        if (!code == false) {
          that.recommend = code;
          window.sessionStorage.setItem("rePhone", code);
        } else if (!rePhone == false) {
          that.recommend = rePhone;
          window.sessionStorage.setItem("rePhone", rePhone);
        }
      }
    },
    getCaptcha() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "getSmsPic",
          },
        })
        .then(function (res) {
          let resData = res.data;
          if (resData.code == 1) {
            that.captcha = resData.data.code_url;
            that.verify_token = resData.data.verify_token;
          } else if (resData.code == 0) {
            that.disabled = false;
            that.$toast.fail(res.data.msg);
          }
        });
      // this.captcha = 'https://server.hk9999z.com/captcha?v='+Math.random();
    },
  },
  mounted: function () {
    this.realNameConfig();
    this.isLogin();
    this.isCode();
    this.getCaptcha();
    this.get_qchat_server_url();
  },
};
</script>

<style scoped>
.wrap {
  width: 90%;
  margin: 0 auto;
}
.logo {
  width: 50%;
  margin: 25px auto 0;
}
.chatTextDesign {
  border: 1px solid #ffffff;
  color: #ffffff;
  font-size: 12px;
  padding: 0px 12px;
  border-radius: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/Register.vue